import { NostrEvent } from '@nostr/tools/core'
import { Content } from '@tiptap/react'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'
import { sha256 } from '@noble/hashes/sha2.js'
import { SelectableItem } from '../RelaySelector'
import { PrimitiveAtom } from 'jotai'

export type TComposerState = {
  nsfw: boolean
  quietReply: boolean
  protected: boolean
  relaySelection: SelectableItem[]
  content: Content
}

const composerStates = new Map()

export function getComposerStateAtom(
  defaultContent: string,
  parentEvents: undefined | NostrEvent[],
  openFromRelay: string[] | undefined,
  init: () => TComposerState
): PrimitiveAtom<TComposerState> {
  let key = parentEvents?.map((pe) => pe.id).join(',') || 'new'
  if (defaultContent) key += '/' + sha256(new TextEncoder().encode(defaultContent))
  if (openFromRelay?.length) key += '/r:' + [...openFromRelay].sort().join(',')

  const composerState = composerStates.get(key)
  if (composerState) return composerState

  const storage = createJSONStorage<TComposerState>(() => window.sessionStorage)
  const initial = init()
  const atom = atomWithStorage<TComposerState>(`pec:${key}`, initial, storage)

  composerStates.set(key, atom)

  return atom
}
